<template>
  <div class="TvaSceneTitle">
    <div class="TvaSceneTitle__trackname">{{ truncateString(meta.name, 60)}}</div>
  </div>
</template>
<script>
import { truncateString } from "@/utilities/functions/stringUtils";

export default {
  props: ["meta"],
  methods: {
    truncateString
  }
};
</script>
<style lang="scss" scoped>
.TvaSceneTitle {
  width: 100%;
  height: 52px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: $z-d;

  .desktop & {
    height: 100%;
    width: 35px;
    padding: 0;
    border-right: 1px solid white;
    color: white;
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: $z-d;
    &__trackname {
      position: absolute;
      top: 50%;
      left: 0%;
      transform-origin: 0 0;
      transform: rotate(270deg) translate(-55%, 25%);
      text-align: center;
      display: block;
      width: 300px;
      @include ButtonS;
      white-space: nowrap;
    }
    .button {
      width: 50%;
    }
    &__progressbar {
      width: 4px;
      position: absolute;
      bottom: -1px;
      left: 100%;
      background-color: white;
      transition: all 0.2s ease;
    }
  }
}
</style>
